import Hero from "../components/Hero";
import HeroImage from "../../assets/images/RelevantLifePlan1.jpg";
import relevantLifePlanImage from "../../assets/images/RelevantLifePlan2.jpg";
import Accordion from "../designSystem/Accordion";

const RelevantLifePlanPage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Relevant Life Plan"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">
                What is a Relevant Life Plan?
              </h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                A Relevant Life Plan (RLP) is a tax-efficient life insurance
                policy paid for by a business on behalf of an employee or
                director. If the insured person dies or is diagnosed with a
                terminal illness, a lump sum is paid to their family or
                beneficiaries—not the business.
              </div>
            </div>
            <img
              src={relevantLifePlanImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Key Benefits</h2>
            <div className="divider burgandy" />
            <Accordion title="Tax Efficient">
              Premiums are usually treated as an allowable business expense,
              offering potential Corporation Tax relief. There is typically no
              Income Tax or National Insurance to pay.
            </Accordion>
            <Accordion title="Employee Benefit">
              Helps attract and retain staff by offering valuable life cover.
            </Accordion>
            <Accordion title="Separate from Pensions">
              Does not count towards pension lifetime allowance limits.
            </Accordion>
            <Accordion title="Portable Cover">
              Employees can keep the policy if they leave the business without
              needing a new application.
            </Accordion>
            <Accordion title="Higher Cover Levels">
              Can provide cover of up to around 30x earnings (depending on
              provider), often higher than traditional death-in-service schemes.
            </Accordion>
            <Accordion title="Who is it Suitable For?">
              <div>
                <ul>
                  <li>Company directors and employees paid via PAYE</li>
                  <li>Small businesses that don’t offer group life schemes</li>
                  <li>
                    High earners wanting tax-efficient life cover outside
                    pensions
                  </li>
                </ul>
                Note: Sole traders and partners are not eligible.
              </div>
            </Accordion>
            <Accordion title="How it Works">
              <ul>
                <li>The business pays the premiums</li>
                <li>The policy is written in trust</li>
                <li>
                  If a claim is made, the payout goes directly to the employee’s
                  chosen beneficiaries
                </li>
                <li>
                  Provides financial protection for families in the event of
                  death or terminal illness
                </li>
              </ul>
            </Accordion>
            <Accordion title="Important Information">
              <ul>
                <li>
                  Tax treatment depends on individual circumstances and may
                  change
                </li>
                <li>
                  Trusts and tax planning are not regulated by the Financial
                  Conduct Authority
                </li>
                <li>Policies include terms, conditions, and exclusions</li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RelevantLifePlanPage;
